import {
  AccountInfo,
  IPublicClientApplication,
  InteractionRequiredAuthError
} from '@azure/msal-browser';
import AzureMsalBrowser from './AzureMsalBrowser';

interface MsalConnectorOptions {
  instance: IPublicClientApplication;
  account: AccountInfo | undefined;
  scopes: string[];
}

export const useMsalAccountChecker = () => {
  const { useMsal } = AzureMsalBrowser;
  const { instance, inProgress } = useMsal();

  const account = instance.getActiveAccount();

  if (!account) {
    throw Error(
      'No active account! Verify a user has been signed in and setActiveAccount has been called.'
    );
  }

  return { account, instance, inProgress };
};

export const getMsalFetchOptions = (token: string, additionalHeaders?: object) => ({
  method: 'GET',
  headers: {
    Authorization: `Bearer ${token}`,
    ...additionalHeaders
  }
});

export const acquireTokenSilent = async ({ instance, account, scopes }: MsalConnectorOptions) => {
  try {
    const authResult = await instance.acquireTokenSilent({
      scopes,
      account
    });

    return authResult;
  } catch (error) {
    if (error instanceof InteractionRequiredAuthError) {
      instance.acquireTokenRedirect({
        scopes,
        account
      });
    } else {
      console.error('Error acquiring token silently:', error);
    }
  }

  return undefined;
};
